export const onInitService = ({ createExtension, setContext }) => {
  const _get = (key) => createExtension.sync(key).map(($) => $[0]);

  setContext("one.gates", {
    loading: _get("$ONE_GATE_LOADING"),
    error: _get("$ONE_GATE_ERROR"),
    public: _get("$ONE_GATE_PUBLIC"),
    embed: _get("$ONE_GATE_EMBED"),
    shell: _get("$ONE_GATE_SHELL"),
    auth: _get("$ONE_GATE_AUTH"),
    main: _get("$ONE_GATE")
  });
};
